const View360  = {
    init:function() {
        this.el = $('[component="View-360"]');
        if (!this.el.length) return;

        this.openBtn = $('[opener="view-360"]');
        this.closeBtn = this.el.find(".close");

        this.bind();
    },


    bind:function() {
        this.openBtn.click(function(e) {
            e.preventDefault();

            View360.el.css("display", "block");


            setTimeout(function() {
                View360.el.addClass("visible");
            }, 10);
        });

        this.closeBtn.click(function(event) {
            var popup = $(this)
                .closest("#view-360-row")
                .removeClass("visible");

            setTimeout(function() {
                popup.css("display", "none");
            }, 500);
        });
    },
};

export default View360;